import { render, staticRenderFns } from "./SurveysNav.vue?vue&type=template&id=7d224820&"
import script from "./SurveysNav.vue?vue&type=script&lang=js&"
export * from "./SurveysNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports